import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import { numberFormat } from 'helper';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Breakdown from '../component/Breakdown';
import * as actions from '../../../action';
import * as c from '../../../constant';

function LandTransactionsContainer({
  landTransactionList,
  getLandTransactionList,
  isLoading,
  applicationId,
  getHistoryTransactionList,
  historyApplicationId,
  type,
  permissions,
  handleViewSOA,
}) {
  const setModal = useContext(ModalContext);

  const handleShowBreakdown = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <Breakdown landTransactionList={data} />,
      title: 'Transaction Breakdown',
      modalSize: 'modal-xl',
    });
  };

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    if (type === 'history') getHistoryTransactionList(historyApplicationId);
    else getLandTransactionList(applicationId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    if (type === 'history') getHistoryTransactionList(historyApplicationId);
    else getLandTransactionList(applicationId);
  }, [applicationId]);

  return (
    <div className="card-content-listing">
      <div className="card p-0 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-2">
              <table className="css-table table table-borderless table-sm table-light">
                <thead className="table-header">
                  <tr>
                    <td className="font-weight-bold">TDN</td>
                    <td className="font-weight-bold">PIN</td>
                    <td className="font-weight-bold">QTR</td>
                    <td className="font-weight-bold">Year</td>
                    <td className="font-weight-bold">Amount Due</td>
                    <td />
                  </tr>
                </thead>
                <tbody>
                  {landTransactionList && landTransactionList.length <= 0 && (
                    <tr className="text-center">
                      <td className="history-color" colSpan="7">
                        No data
                      </td>
                    </tr>
                  )}
                  {landTransactionList &&
                    landTransactionList.map((item) => (
                      <tr key={item.id}>
                        <td className="align-middle">
                          <span style={{ color: '#65676b' }}>
                            {(type === 'history'
                              ? _.get(
                                  item,
                                  'included.land_history_log.attributes.tdn'
                                )
                              : _.get(
                                  item,
                                  'included.land_application.attributes.tdn'
                                )) || ''}
                          </span>
                        </td>
                        <td className="align-middle">
                          <span style={{ color: '#65676b' }}>
                            {(type === 'history'
                              ? _.get(
                                  item,
                                  'included.land_history_log.attributes.pin'
                                )
                              : _.get(
                                  item,
                                  'included.land_application.attributes.pin'
                                )) || ''}
                          </span>
                        </td>
                        <td className="align-middle">
                          <span style={{ color: '#65676b' }}>
                            {_.get(item, 'attributes.qtr') || ''}
                          </span>
                        </td>
                        <td className="align-middle">
                          <span style={{ color: '#65676b' }}>
                            {_.get(item, 'attributes.year') || ''}
                          </span>
                        </td>
                        <td className="align-middle">
                          <span style={{ color: '#65676b' }}>
                            {numberFormat(
                              _.get(item, 'attributes.amount_due'),
                              2
                            ) || ''}
                          </span>
                        </td>
                        <td width="250">
                          <button
                            onClick={handleShowBreakdown(item)}
                            type="button"
                            className="btn btn-black font-weight-bold mr-2"
                          >
                            Breakdown
                          </button>
                          {Acl(permissions, ['E2E RPT LAND PREVIEW SOA']) && (
                            <button
                              type="button"
                              onClick={handleViewSOA(item, applicationId)}
                              className="btn btn-black font-weight-bold mr-2"
                            >
                              View SOA
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

LandTransactionsContainer.defaultProps = {
  type: '',
  applicationId: '',
  historyApplicationId: '',
};

LandTransactionsContainer.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  landTransactionList: PropTypes.instanceOf(Array).isRequired,
  getLandTransactionList: PropTypes.instanceOf(Function).isRequired,
  getHistoryTransactionList: PropTypes.instanceOf(Function).isRequired,
  handleViewSOA: PropTypes.instanceOf(Function).isRequired,
  permissions: PropTypes.instanceOf(Array).isRequired,
  applicationId: PropTypes.string,
  historyApplicationId: PropTypes.string,
  type: PropTypes.string,
};

const mapStateToProps = ({ api }) => ({
  landTransactionList: _.get(api, `${c.GET_LAND_TRANSACTION}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_LAND_TRANSACTION) > -1,
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(LandTransactionsContainer);
